export const preferredEndpoints = {
    osmosis: {
        rpc: ['https://atom4.a.exodus.io/api'],
    },
};
